<template>
  <div>
    <div class="container box-login">
      <img src="@/assets/images/logoLogin.png" class="logo" alt="" srcset="" />
      <h6 class="center-align" style="color: #BCBCBC">
        Insira seus dados para continuar
      </h6>
      <div class="title-divider" />
      <form @submit.prevent="login" style="max-width: 400px">
        <div class="row box-inputs">
          <div class="input-field col s12">
            <label for="email">Usuário</label>
            <input
              type="email"
              v-model="form.email"
              name="email"
              id="email"
              v-validate="'required|email'"
              :class="{ invalid: errors.first('email') }"
            />
            <span
              class="helper-text"
              :data-error="errors.first('email')"
            ></span>
          </div>
          <div class="col s12">
            <div class="input-field password-input">
              <i
                class="material-icons"
                @click="visibilityPassword = !visibilityPassword"
                >{{ visibilityPassword ? "visibility_off" : "visibility" }}</i
              >
              <label for="password">Senha</label>
              <input
                :type="visibilityPassword ? 'text' : 'password'"
                name="password"
                id="password"
                v-model="form.password"
                v-validate="'required'"
                :class="{ invalid: errors.first('password') }"
              />
              <span
                class="helper-text"
                :data-error="errors.first('password')"
              ></span>
            </div>
          </div>
        </div>

        <div class="links">
          <router-link
            :to="{ name: 'forgetPassword' }"
            class="text-primary-color link"
            tag="a"
            >Esqueci minha senha.</router-link
          >
        </div>

        <div class="actions">
          <button
            class="waves-effect waves-light btn-large"
            type="submit"
            :class="{ load: load }"
          >
            <feather v-if="load" type="loader" animation="spin" />
            <template v-else
              >Entrar</template
            >
          </button>
        </div>
      </form>
    </div>
    <div
      class="toast-error"
      :class="{ 'toast-error--open': errorSession }"
      @click="errorSession = false"
    >
      <i class="toast-error__icon material-icons">error</i>
      <p class="toast-error__title">
        Sessão do usuário expirou, faça a autenticação novamente.
      </p>
    </div>
  </div>
</template>

<script>
import encryptation from "@/services/mixins/encryptation";

export default {
  name: "Login",
  mixins: [encryptation],
  data: () => ({
    errorSession: false,
    visibilityPassword: false,
    load: false,
    form: {
      email: "",
      password: ""
    }
  }),
  mounted() {
    setTimeout(() => {
      const error = localStorage.getItem("error-session");
      if (error) this.errorSession = true;
    }, 300);

    setTimeout(() => {
      this.errorSession = false;
      localStorage.removeItem("error-session");
    }, 5000);

    /*** remove toast while refresh page */
    window.addEventListener("beforeunload", function(event) {
      event.preventDefault();
      localStorage.removeItem("error-session");
    });
  },
  methods: {
    async login() {
      this.load = true;
      try {
        await this.$validator.validateAll();
        if (!this.errors.items.length > 0) {
          const jwt = await this.$http.post("auth/sign-in", {
            ...this.form
          });
          const { token_type, access_token } = jwt.data.data;

          const user = await this.$http.get("auth/me", {
            headers: {
              Authorization: `${token_type} ${access_token}`
            }
          });

          const data = {
            expiration: this.$moment().add(10, "days"),
            jwt: jwt.data.data,
            user: user.data.data.user
          };
          localStorage.setItem("cache", this.encrypt(data).toString());
          this.$router.push({ name: "home" });
        }
      } catch (e) {
        M.toast({
          html:
            "Nenhum registro foi encontrado com os dados mencionados, Por favor verifique e tente novamente.",
          displayLength: 5000
        });
        this.load = false;
      }
      this.load = false;
    }
  },
  beforeDestroy() {
    M.Toast.dismissAll();
    localStorage.removeItem("error-session");
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/components/variables.scss";

.toast-error {
  position: fixed;
  top: 64px;
  @media #{$small-and-down} {
    top: 0px;
    right: 0;
    border-radius: 0;
    transform: translateY(-80px);
  }
  right: 32px;
  padding: 16px;
  min-width: 200px;
  background: #ef8686;
  border-radius: 4px;
  transition: all 0.2s ease-out;
  opacity: 0;
  display: flex;
  align-items: center;

  &__title {
    margin: 0;
    color: #fdfdfd;
  }

  &__icon {
    margin-right: 8px;
  }

  &--open {
    transform: translateY(48px);
    opacity: 1;
    @media #{$small-and-down} {
      transform: translateY(0);
    }
  }
}

.title-divider {
  height: 50px;
}

.box-login {
  max-width: 450px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .logo {
    margin-bottom: 24px;
  }
  .links {
    display: flex;
    justify-content: center;
    margin-bottom: 40px;
  }

  .actions {
    width: 100%;
    display: flex;
    justify-content: center;
    button {
      width: 35vh;
    }

    @media #{$small-and-down} {
      button {
        width: 100%;
      }
    }
  }
}

@media #{$small-and-down} {
  .box-inputs {
    margin-bottom: 0;
  }
  .link {
    margin: 0;
  }
}
</style>
